import { getCount } from '@/requests/api/get-count';
import { type ApartmentQueue } from '@pigello/pigello-matrix';
import type { TCustomList } from './types';

export async function handleCustomApartmentQueueNestedCase(
  listResponse: TCustomList<ApartmentQueue>
): Promise<
  TCustomList<
    ApartmentQueue & {
      totalEnrollmentCount: number;
    }
  >
> {
  const queueIds = new Set<string>();

  for (const queue of listResponse.data) {
    queueIds.add(queue.id);
  }

  const resolvedEnrollmentPromises = await Promise.allSettled(
    Array.from(queueIds).map(async (queueId) => {
      const enrollmentCount = await getCount({
        modelName: 'apartmentqueueenrollment',
        filters: {
          queue: { noop: queueId },
          soft_deleted_at: { __isnull: true },
        },
      });
      return { queueId, enrollmentCount };
    })
  );

  const results = resolvedEnrollmentPromises.map((promise) => {
    if (promise.status === 'fulfilled') {
      return promise.value;
    }
    return null;
  });

  const mappedListResponse = {
    data: listResponse.data.map((queue) => {
      return {
        ...queue,
        totalEnrollmentCount:
          results.find((result) => result?.queueId === queue.id)
            ?.enrollmentCount ?? 0,
      };
    }),
  };

  return mappedListResponse;
}
